import React from "react";
import { Card, CardBody, Spinner } from "reactstrap";

function StatCard({ title, value, subtitle, color = "#8B9736", Icon, statsLoader }) {
  return (
    <Card
      style={{
        border: "1px solid #E5E7EB",
        height: "100%",
        minWidth: 0, // helps on smaller screens
        flex: 1,     // allow card to grow/shrink
      }}
      className="stat-card"
    >
      <CardBody
        style={{
          padding: "1rem", // equivalent to 16px
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "0.25rem", // ~4px
        }}
      >
        {/* Icon at top-right */}
        {Icon && (
          <Icon
            size={18}
            style={{
              position: "absolute",
              top: "1rem",
              right: "1rem",
              color,
            }}
          />
        )}

        {/* Title */}
        <span
          style={{
            fontSize: "0.875rem", // 14px
            fontWeight: 500,
            color: "#3C3C3C",
          }}
        >
          {title}
        </span>

        {/* Value with spinner */}
        <span
          style={{
            fontSize: "1.5rem", // 24px
            fontWeight: 700,
            color,
            lineHeight: 1.2,
            minHeight: "28px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {statsLoader ? <Spinner size="sm" color="secondary" /> : value}
        </span>

        {/* Subtitle */}
        <span
          style={{
            fontSize: "0.75rem", // 12px
            color: "#6C6C6C",
          }}
        >
          {subtitle}
        </span>
      </CardBody>
    </Card>
  );
}

export default StatCard;
